import styled from 'styled-components';
import Button from './index';

const PillButton = styled(Button)`
  display: inline-block;
  padding: 8px 16px;
  width: auto;
  width: initial;
  border-radius: 24px;
  white-space: nowrap;
`;

export default PillButton;
